
(function () {
  'use strict';

  var timer;

  function load() {
    var slot = document.getElementById('wc-cart-recs-slot');
    if (!slot) return;
    fetch('/?section_id=cart-recommendations', { credentials: 'same-origin' })
      .then(function (r) { return r.ok ? r.text() : ''; })
      .then(function (html) {
        
        var s = document.getElementById('wc-cart-recs-slot');
        if (!s) return;
        if (!html) { s.innerHTML = ''; return; }
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var recs = doc.querySelector('.wc-cart-recs');
        s.innerHTML = recs ? recs.outerHTML : '';
      })
      .catch(function () {  });
  }

  function schedule() {
    clearTimeout(timer);
    timer = setTimeout(load, 600);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', load);
  } else {
    load();
  }

  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.cartUpdate, schedule);
  }
})();
